import React, { useState } from 'react';
import { useSimulatorStore } from './store/simulatorStore';
import TopBar from './components/panels/TopBar';
import ComponentLibrary from './components/panels/ComponentLibrary';
import Workspace from './components/panels/Workspace';
import ResultsPanel from './components/panels/ResultsPanel';
import CircuitBuilder from './components/circuit/CircuitBuilder';
import './App.css';

export type AppMode = 'lab' | 'circuit';

export default function App() {
  const [mode, setMode] = useState<AppMode>('lab');
  const { ageMode, result, status, activePreset, showHint } = useSimulatorStore();

  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      fontFamily: 'system-ui, -apple-system, sans-serif',
    }}>
      {/* Top Bar */}
      <TopBar mode={mode} onModeChange={setMode} />

      {/* ── Experiment Lab ── */}
      {mode === 'lab' && (
        <>
          {showHint && activePreset && (
            <div style={{
              background: 'linear-gradient(90deg, #fef3c7, #fde68a)',
              borderBottom: '1px solid #fbbf24',
              padding: '8px 20px',
              fontSize: 12,
              color: '#78350f',
              display: 'flex',
              alignItems: 'center',
              gap: 10,
            }}>
              <span style={{ fontSize: 16 }}>💡</span>
              <strong style={{ marginRight: 4 }}>{activePreset.name}:</strong>
              {activePreset.hint}
            </div>
          )}
          <div style={{ flex: 1, display: 'flex', overflow: 'hidden' }}>
            <ComponentLibrary ageMode={ageMode} />
            <Workspace />
            <ResultsPanel
              result={result}
              status={status}
              activePresetHint={activePreset?.hint}
              activePresetSteps={activePreset?.steps}
            />
          </div>
        </>
      )}

      {/* ── Circuit Builder ── */}
      {mode === 'circuit' && (
        <div style={{ flex: 1, display: 'flex', overflow: 'hidden' }}>
          <CircuitBuilder />
        </div>
      )}
    </div>
  );
}
